import { AxiosError } from 'axios';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { useRecreateProductName } from '@/hooks/useRecreateProductName';
import { useVerifyCreateNameModel } from '@/hooks/useVerifyCreateNameModel';

interface RecreateNameButtonProps {
  catalogId: number;
}

export function RecreateNameButton({ catalogId }: RecreateNameButtonProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.VisionProduct.components.RecreateNameButton',
  });

  const { hasModel } = useVerifyCreateNameModel();
  const { isLoading, recreateProductName } = useRecreateProductName(catalogId);

  if (!hasModel) {
    return null;
  }

  async function handleRecreate() {
    try {
      await recreateProductName();
    } catch (error) {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.message
          : t('error');
      toast.error(message);
    }
  }

  return (
    <Button
      onClick={handleRecreate}
      disabled={isLoading}
      variant="outline"
      className="flex items-center gap-2 bg-transparent"
    >
      <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
      {isLoading ? t('rerunning') : t('label')}
    </Button>
  );
}
